// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-GMM","right":"styles_right__1ILOz"};